import React from 'react';
import { Phone, MapPin, Clock, Facebook } from 'lucide-react';

const Contact = () => {
  const handleCall = () => {
    window.location.href = 'tel:+33978802623';
  };

  const handleDirections = () => {
    window.open('https://www.google.com/maps/search/?api=1&query=1+Place+du+18+Novembre+1944,+90600+Grandvillars', '_blank');
  };

  const handleFacebook = () => {
    window.open('https://www.facebook.com', '_blank');
  };

  return (
    <main className="min-h-screen">
      <div className="pt-20">
        {/* Contact Section */}
        <section className="section bg-white">
          <div className="container mx-auto transition-all duration-700 opacity-100 translate-y-0">
            <div className="max-w-2xl mx-auto">
              <h2 className="heading-lg mb-8 text-gray-900 text-center">Nous contacter</h2>
              <div className="space-y-6 mb-8">
                {/* Phone */}
                <div className="bg-red-50 p-6 rounded-lg border-l-4 border-red-500">
                  <div className="flex items-center gap-4">
                    <Phone className="w-8 h-8 text-red-600" />
                    <div>
                      <h3 className="heading-sm text-red-800 mb-1">Appel direct</h3>
                      <button onClick={handleCall} className="text-lg font-bold text-red-700 hover:text-red-800 transition-colors">
                        +33 9 78 80 26 23
                      </button>
                      <p className="text-sm text-red-600 mt-1">Réponse immédiate aux horaires d'ouverture</p>
                    </div>
                  </div>
                </div>

                {/* Facebook */}
                <div className="bg-blue-50 p-6 rounded-lg border-l-4 border-blue-500">
                  <div className="flex items-center gap-4">
                    <Facebook className="w-8 h-8 text-blue-600" />
                    <div>
                      <h3 className="heading-sm text-blue-800 mb-1">Messager</h3>
                      <button onClick={handleFacebook} className="text-lg font-semibold text-blue-700 hover:text-blue-800 transition-colors">
                        Nous écrire sur Facebook
                      </button>
                      <p className="text-sm text-blue-600 mt-1">Messagerie instantanée et suivi des actualités</p>
                    </div>
                  </div>
                </div>

                {/* Visit */}
                <div className="bg-green-50 p-6 rounded-lg border-l-4 border-green-500">
                  <div className="flex items-start gap-4">
                    <MapPin className="w-8 h-8 text-green-600 mt-1" />
                    <div>
                      <h3 className="heading-sm text-green-800 mb-2">Visite en boutique</h3>
                      <p className="text-green-700 font-medium mb-2">
                        1 Place du 18 Novembre 1944, 90600 Grandvillars
                      </p>
                      <button onClick={handleDirections} className="btn btn-outline btn-sm text-green-700 border-green-600 hover:bg-green-600 hover:text-white">
                        <MapPin className="w-4 h-4" />
                        Itinéraire
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              {/* Hours */}
              <div className="bg-gray-50 p-6 rounded-lg">
                <h3 className="heading-sm mb-4 flex items-center gap-2 text-gray-900">
                  <Clock className="w-5 h-5 text-green-600" />
                  Horaires d'ouverture
                </h3>
                <div className="space-y-2">
                  <div className="flex justify-between items-center text-sm">
                    <span className="font-medium text-gray-700">Mardi-Vendredi</span>
                    <span className="font-bold text-green-600">09:00–18:30</span>
                  </div>
                  <div className="flex justify-between items-center text-sm">
                    <span className="font-medium text-gray-700">Samedi</span>
                    <span className="font-bold text-green-600">09:00–17:30</span>
                  </div>
                  <div className="flex justify-between items-center text-sm">
                    <span className="font-medium text-gray-700">Dimanche-Lundi</span>
                    <span className="font-bold text-red-600">fermé</span>
                  </div>
                </div>
                <p className="text-xs text-gray-500 mt-3">* Horaires susceptibles d'évoluer selon les saisons</p>
              </div>

              {/* Response Time */}
              <div className="mt-6 bg-yellow-50 p-4 rounded-lg border-l-4 border-yellow-400">
                <h4 className="font-semibold text-yellow-800 mb-2">Temps de réponse</h4>
                <div className="space-y-1 text-sm text-yellow-700">
                  <p>• Téléphone : Immédiat aux heures d'ouverture</p>
                  <p>• Messenger : Quelques heures</p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </main>
  );
};

export default Contact;